import apiSlice from './apiSlice';

export interface FancyLastBet {
  betOn: 'Back' | 'Lay' | string;
  amount: number | string;
  percentage: string | number;
}

export interface ExposureSelection {
  selectionId: string;
  exposure: number | string | null;
  potentialProfit: number;
  lastBetType: FancyLastBet;
}

export interface ExposureMarket {
  marketId: number;
  marketExternalId: string;
  selections: ExposureSelection[];
}

export type ExposureResponse = ExposureMarket[];

export interface ExposureQuery {
  eventId: string | number;
}

export interface ProfitLossItem {
  position: number;
  profit_or_loss: number;
}

export type ProfitLossResponse = ProfitLossItem[];

export interface ProfitLossQuery {
  eventId: number;
  selectionId: string;
  marketId?: string | number;
}

export const exposureApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBooksetCalc: builder.query<ExposureResponse, ExposureQuery>({
      query: (params) => ({
        url: '/exposure/bookset/calculation',
        method: 'GET',
        params: { ...params, t: Date.now() },
        requiresAuth: true,
      }),
      providesTags: ['Bookset'],
    }),

    getFancyProfitLoss: builder.query<ProfitLossResponse, ProfitLossQuery>({
      query: (params) => ({
        url: '/exposure/profit-loss',
        method: 'GET',
        params: { ...params, t: Date.now() },
        requiresAuth: true,
      }),
    }),
  }),
});

export const {
  useGetBooksetCalcQuery,
  useGetFancyProfitLossQuery,
  useLazyGetFancyProfitLossQuery,
} = exposureApi;
